// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Lcu_onbD5Mo7xu6uE7tu{gap:6px;padding-top:4px;display:flex}.Lcu_onbD5Mo7xu6uE7tu .czT6fIVRguMOU3H9CFXp{width:18px;box-shadow:inset 0 0 0 1px var(--black-20);border-radius:4px;justify-content:center;padding-top:1px;line-height:13px;display:flex}.gPzd7EHg4sHTQn3LsTiH{align-items:flex-start;height:300px;margin-top:20px;margin-bottom:4px;display:flex}#shortcutTooltip[data-popper-placement*=top] .gPzd7EHg4sHTQn3LsTiH{align-items:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortcutInfo": `Lcu_onbD5Mo7xu6uE7tu`,
	"shortcut": `czT6fIVRguMOU3H9CFXp`,
	"wrapTooltip": `gPzd7EHg4sHTQn3LsTiH`
};
export default ___CSS_LOADER_EXPORT___;
